// import { FeedService } from '@pingum/api-services';
import FeedService from '../../services/FeedService';
import * as types from './types';
import {
  dispatchNetworkRequest,
  dispatchNetworkRequestDynamicSuccessDispatch,
} from '../networkDispatcher';

export const getFeeds = (page = 0, pageSize = 25, sort = '', search = '') => (dispatch) => {
  const promise = FeedService.getFeeds(page, pageSize, sort, search);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_FEED_REQUESTED,
    successType: types.GET_FEED_SUCCESS,
    errorType: types.GET_FEED_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading feeds for this organization',
    responseName: 'feeds',
  });
  return promise;
};

export const addFeed = (request) => (dispatch) => {
  const promise = FeedService.addFeed(request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.ADD_FEED_REQUESTED,
    successType: types.ADD_FEED_SUCCESS,
    errorType: types.ADD_FEED_ERROR,
    promise,
    successMessage: 'Successfully created the feed',
    defaultErrorMessage: 'There was a problem adding the feed to the organization',
    responseName: 'newFeed',
  });
  return promise;
};

export const updateFeed = (id, request) => (dispatch) => {
  const promise = FeedService.updateFeed(id, request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.UPDATE_FEED_REQUESTED,
    successType: types.UPDATE_FEED_SUCCESS,
    errorType: types.UPDATE_FEED_ERROR,
    promise,
    successMessage: 'Successfully updated the feed',
    defaultErrorMessage: 'There was a problem updating the feed',
    responseName: 'updatedFeed',
  });
  return promise;
};

export const deleteFeed = (id, deleteHorseFeeds = false) => (dispatch) => {
  const promise = FeedService.deleteFeed(id, deleteHorseFeeds);
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: types.DELETE_FEED_REQUESTED,
    successDispatch: {
      type: types.DELETE_FEED_SUCCESS,
      deletedFeedId: id,
    },
    errorType: types.DELETE_FEED_ERROR,
    promise,
    successMessage: 'Successfully deleted the feed',
    defaultErrorMessage: 'There was a problem deleting the feed',
    responseName: 'response',
  });
  return promise;
};

export const getHorsesForFeed = (id) => (dispatch) => {
  const promise = FeedService.getHorsesForFeed(id);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_HORSE_FEED_REQUESTED,
    successType: types.GET_HORSE_FEED_SUCCESS,
    errorType: types.GET_HORSE_FEED_ERROR,
    promise,
    successMessage: 'Successfully retrieved horses for feed',
    defaultErrorMessage: 'There was a problem getting horses for this feed',
    responseName: 'horseFeeds',
  });
  return promise;
};
